// Excel / CSV attachments open in a new tab, in GridCraft, instead of
// downloading. The tab is public/spreadsheet.html: it fetches the attachment
// from the bot's own route (with the session cookie) and hands the bytes to
// GridCraft, which the bot serves from /gridcraft/ (scripts/fetch-gridcraft.js).
// Nothing goes to a third party. The chip's menu keeps Download.

// What GridCraft reads: xlsx/xlsm (its own format), legacy .xls (values,
// formulas and number formats; not yet formatting), csv and tsv.
const EXTENSIONS = ['xlsx', 'xlsm', 'xls', 'csv', 'tsv'];

const MIME_EXT = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
  'application/vnd.ms-excel': 'xls',
  'text/csv': 'csv',
  'text/tab-separated-values': 'tsv',
};

function extensionOf(name) {
  return (String(name || '').match(/\.([a-z0-9]+)$/i)?.[1] || '').toLowerCase();
}

/** The extension the viewer should read the file as, or '' if it isn't a spreadsheet. */
export function spreadsheetExtension(att) {
  const ext = extensionOf(att?.name);
  if (EXTENSIONS.includes(ext)) return ext;
  // A name with some other extension (.pdf, .zip…) is that file, whatever the
  // content type says. Only a name with none falls back to the content type.
  if (ext) return '';
  return MIME_EXT[String(att?.contentType || '').toLowerCase().split(';')[0].trim()] || '';
}

export function isSpreadsheetAttachment(att) {
  return !!spreadsheetExtension(att);
}

/**
 * The new-tab URL showing this attachment in the viewer.
 * @param {string} src  the attachment's download path (…/attachments/:aid, already withImpersonate'd)
 */
export function spreadsheetViewerUrl(att, src) {
  const ext = spreadsheetExtension(att) || 'xlsx';
  let name = String(att?.name || '').trim() || 'spreadsheet';
  if (extensionOf(name) !== ext) name += `.${ext}`;
  return `/spreadsheet.html?src=${encodeURIComponent(src)}&name=${encodeURIComponent(name)}`;
}
